module.exports = __webpack_public_path__ + "img/7.3700f7d0.png";